// Importing images of Authors
import NelsonMandela from '../images/quote-authors/nelson-mandela.png';
import WaltDisney from '../images/quote-authors/walt-disney.png';
import SteveJobs from '../images/quote-authors/steve-jobs.png';
import EleanorRoosevelt from '../images/quote-authors/eleanor-roosevelt.png';
import OprahWinfrey from '../images/quote-authors/oprah-winfrey.png';
import JamesCameron from '../images/quote-authors/james-cameron.png';
import JohnLennon from '../images/quote-authors/john-lennon.png';
import MotherTheresa from '../images/quote-authors/mother-theresa.png';
import FranklinDRoosevelt from '../images/quote-authors/franklin-d-roosevelt.png';
import MargaretMead from '../images/quote-authors/margaret-mead.png';
import RobertLouisStevenson from '../images/quote-authors/robert-louis-stevenson.png';
import BenjaminFranklin from '../images/quote-authors/benjamin-franklin.png';
import HelenKeller from '../images/quote-authors/helen-keller.png';
import Aristotle from '../images/quote-authors/aristotle.png';
import AnneFrank from '../images/quote-authors/anne-frank.png';
import RalphWaldoEmerson from '../images/quote-authors/ralph-waldo-emerson.png';
import MayaAngelou from '../images/quote-authors/maya-angelou.png';
import AbrahamLincoln from '../images/quote-authors/abraham-lincoln.png';
import BabeRuth from '../images/quote-authors/babe-ruth.png';
import ThomasEdison from '../images/quote-authors/thomas-edison.png';
import DrSeuss from '../images/quote-authors/dr-seuss.png';
import WinstonChurchill from '../images/quote-authors/winston-churchill.png';
import HenryDavidThoreau from '../images/quote-authors/henry-david-thoreau.png';
import JohnDRockefellarJr from '../images/quote-authors/john-d-rockefellar-jr.png';
import ThomasJefferson from '../images/quote-authors/thomas-jefferson.png';
import AudreyHepburn from '../images/quote-authors/audrey-hepburn.png';
import WayneGretzky from '../images/quote-authors/wayne-gretzky.png';


export const QuoteData = [
    {
        id: 0,
        quote: "The greatest glory in living lies not in never falling, but in rising every time we fall",
        author: "Nelson Mandela",
        image: NelsonMandela,
        wiki: "https://en.wikipedia.org/wiki/Nelson_Mandela",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 1,
        quote: "The way to get started is to quit talking and begin doing",
        author: "Walt Disney",
        image: WaltDisney,
        wiki: "https://en.wikipedia.org/wiki/Walt_Disney",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 2,
        quote: "Your time is limited, so don't waste it living someone else's life. Don't be trapped by dogma – which is living with the results of other people's thinking",
        author: "Steve Jobs",
        image: SteveJobs,
        wiki: "https://en.wikipedia.org/wiki/Steve_Jobs",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 3,
        quote: "If life were predictable it would cease to be life, and be without flavor",
        author: "Eleanor Roosevelt",
        image: EleanorRoosevelt,
        wiki: "https://en.wikipedia.org/wiki/Eleanor_Roosevelt",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 4,
        quote: "If you look at what you have in life, you'll always have more. If you look at what you don't have in life, you'll never have enough",
        author: "Oprah Winfrey",
        image: OprahWinfrey,
        wiki: "https://en.wikipedia.org/wiki/Oprah_Winfrey",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 5,
        quote: "If you set your goals ridiculously high and it's a failure, you will fail above everyone else's success",
        author: "James Cameron",
        image: JamesCameron,
        wiki: "https://en.wikipedia.org/wiki/James_Cameron",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 6,
        quote: "Life is what happens when you're busy making other plans",
        author: "John Lennon",
        image: JohnLennon,
        wiki: "https://en.wikipedia.org/wiki/John_Lennon",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 7,
        quote: "Spread love everywhere you go. Let no one ever come to you without leaving happier",
        author: "Mother Theresa",
        image: MotherTheresa,
        wiki: "https://en.wikipedia.org/wiki/Mother_Teresa",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 8,
        quote: "When you reach the end of your rope, tie a knot in it and hang on",
        author: "Franklin D. Roosevelt",
        image: FranklinDRoosevelt,
        wiki: "https://en.wikipedia.org/wiki/Franklin_D._Roosevelt",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 9,
        quote: "Always remember that you are absolutely unique. Just like everyone else",
        author: "Margaret Mead",
        image: MargaretMead,
        wiki: "https://en.wikipedia.org/wiki/Margaret_Mead",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 10,
        quote: "Don't judge each day by the harvest you reap but by the seeds that you plant",
        author: "Robert Louis Stevenson",
        image: RobertLouisStevenson,
        wiki: "https://en.wikipedia.org/wiki/Robert_Louis_Stevenson",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 11,
        quote: "The future belongs to those who believe in the beauty of their dreams",
        author: "Eleanor Roosevelt",
        image: EleanorRoosevelt,
        wiki: "https://en.wikipedia.org/wiki/Eleanor_Roosevelt",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 12,
        quote: "Tell me and I forget. Teach me and I remember. Involve me and I learn",
        author: "Benjamin Franklin",
        image: BenjaminFranklin,
        wiki: "https://en.wikipedia.org/wiki/Benjamin_Franklin",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 13,
        quote: "The best and most beautiful things in the world cannot be seen or even touched — they must be felt with the heart",
        author: "Helen Keller",
        image: HelenKeller,
        wiki: "https://en.wikipedia.org/wiki/Helen_Keller",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 14,
        quote: "It is during our darkest moments that we must focus to see the light",
        author: "Aristotle",
        image: Aristotle,
        wiki: "https://en.wikipedia.org/wiki/Aristotle",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 15,
        quote: "Whoever is happy will make others happy too",
        author: "Anne Frank",
        image: AnneFrank,
        wiki: "https://en.wikipedia.org/wiki/Anne_Frank",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 16,
        quote: "Do not go where the path may lead, go instead where there is no path and leave a trail",
        author: "Ralph Waldo Emerson",
        image: RalphWaldoEmerson,
        wiki: "https://en.wikipedia.org/wiki/Ralph_Waldo_Emerson",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 17,
        quote: "You will face many defeats in life, but never let yourself be defeated",
        author: "Maya Angelou",
        image: MayaAngelou,
        wiki: "https://en.wikipedia.org/wiki/Maya_Angelou",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 18,
        quote: "The greatest glory in living lies not in never falling, but in rising every time we fall",
        author: "Nelson Mandela",
        image: NelsonMandela,
        wiki: "https://en.wikipedia.org/wiki/Nelson_Mandela",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 19,
        quote: "In the end, it's not the years in your life that count. It's the life in your years",
        author: "Abraham Lincoln",
        image: AbrahamLincoln,
        wiki: "https://en.wikipedia.org/wiki/Abraham_Lincoln",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 20,
        quote: "Never let the fear of striking out keep you from playing the game",
        author: "Babe Ruth",
        image: BabeRuth,
        wiki: "https://en.wikipedia.org/wiki/Babe_Ruth",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 21,
        quote: "Life is either a daring adventure or nothing at all",
        author: "Helen Keller",
        image: HelenKeller,
        wiki: "https://en.wikipedia.org/wiki/Helen_Keller",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 22,
        quote: "Many of life's failures are people who did not realize how close they were to success when they gave up",
        author: "Thomas A. Edison",
        image: ThomasEdison,
        wiki: "https://en.wikipedia.org/wiki/Thomas_Edison",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 23,
        quote: "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose",
        author: "Dr. Seuss",
        image: DrSeuss,
        wiki: "https://en.wikipedia.org/wiki/Dr._Seuss",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 24,
        quote: "Success is not final; failure is not fatal: It is the courage to continue that counts",
        author: "Winston S. Churchill",
        image: WinstonChurchill,
        wiki: "https://en.wikipedia.org/wiki/Winston_Churchill",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 25,
        quote: "Success usually comes to those who are too busy to be looking for it",
        author: "Henry David Thoreau",
        image: HenryDavidThoreau,
        wiki: "https://en.wikipedia.org/wiki/Henry_David_Thoreau",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 26,
        quote: "The secret of success is to do the common thing uncommonly well",
        author: "John D. Rockefeller Jr.",
        image: JohnDRockefellarJr,
        wiki: "https://en.wikipedia.org/wiki/John_D._Rockefeller_Jr.",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 27,
        quote: "I find that the harder I work, the more luck I seem to have",
        author: "Thomas Jefferson",
        image: ThomasJefferson,
        wiki: "https://en.wikipedia.org/wiki/Thomas_Jefferson",
        favourited: false,
        narrator: 'male',
    },
    {
        id: 28,
        quote: "Nothing is impossible, the word itself says, ‘I'm possible!'",
        author: "Audrey Hepburn",
        image: AudreyHepburn,
        wiki: "https://en.wikipedia.org/wiki/Audrey_Hepburn",
        favourited: false,
        narrator: 'female',
    },
    {
        id: 29,
        quote: "You miss 100% of the shots you don't take",
        author: "Wayne Gretzky",
        image: WayneGretzky,
        wiki: "https://en.wikipedia.org/wiki/Wayne_Gretzky",
        favourited: false,
        narrator: 'male',
    },
]